import { Injectable } from '@angular/core';
import {
    Router,
    CanActivateChild,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from '@angular/router';
import { AccountService } from './account.service';

@Injectable({
    providedIn: 'root',
})
export class IsAuthenticatedGuardService implements CanActivateChild {
    constructor(
        private router: Router,
        private accountService: AccountService,
    ) {}

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) {
        if (this.accountService.isLoggedIn()) {
            return true;
        } else {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: state.url,
                },
            });
            return false;
        }
    }
}
